import request from '@/utils/request';
// let orgCode = window.sessionStorage.getItem("orgCode");
//门户style
export function getStyleList() {
    return request({
        url: '/dashboard/home/stylelist',
        method: 'get',
        params:{orgCode:window.sessionStorage.getItem("orgCode")}
    })
  }

  // 右上角列表
  export function getMsgList(data) {
    return request({
        url: 'bussiness/notice/getMsgList',
        method: 'get',
        params:data
    })
  }
  //右上角消息数量 
  export function getMsgCount() {
    return request({
        url: 'bussiness/notice/getMsgCount',
        method: 'get'
    })
  }


// WEBPACK FOOTER //
// ./src/api/webStyle.js